import { Fragment } from 'react';
import { Link } from '@hc/redux-saga-router-plus';

import { ValuationChartSection } from 'legacy/containers/valuation-chart-section';

import { Dialog } from 'legacy/components/Dialog';
import ChartButton from 'legacy/components/ChartButton';

import { PropertyExplorerCharts as chartTheme } from 'legacy/css-modules';

const PropertyExplorerValuationChartButton = ({
  chartModal,
  chartType,
  similarPropertiesData,
  percentile90Lower,
  percentile90Upper,
  onClose,
  isMobile,
  onClick
}) => {
  return (
    <Fragment>
      <Link
        options={{ inherit: true }}
        query={{ chartModal: 'valuationChart' }}
        className={chartTheme.LinkButton}
        onClick={onClick}
      >
        <ChartButton title={'Similar Properties Sold'}>
          {percentile90Lower && percentile90Upper ? (
            <div className={chartTheme.ChartButtonText}>
              90% of comparable properties sold between $
              <b>{percentile90Lower || null}</b> and $
              <b>{percentile90Upper || null}</b>.
            </div>
          ) : (
            <div className={chartTheme.ChartButtonText}>
              Sorry we do not have enough data about the properties.
            </div>
          )}
        </ChartButton>
      </Link>
      <Dialog
        theme={chartTheme}
        active={chartModal === 'valuationChart'}
        title={
          chartType === 'nearby'
            ? 'See What Similar Homes Sold for in this Neighborhood'
            : 'See What Similar Comps Sold for'
        }
        onClose={onClose}
        closeButton
        className={chartTheme.SimilarHomesChart}
      >
        <ValuationChartSection />
      </Dialog>
    </Fragment>
  );
};

export default PropertyExplorerValuationChartButton;
